import React, { useState } from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS, CategoryScale, LinearScale, BarElement, Tooltip, Legend,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Box, IconButton, Tooltip as MuiTooltip, Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend, ChartDataLabels);

const ordenVentaDataByIndustry2023 = {
  Alimentos: [0,84,90,92,90,91],
  Retail: [0,84,90,92,90,91],
  Logística: [0,84,90,92,90,91],
  Manufactura: [0,84,90,92,90,91],
  Automotriz: [0,84,90,92,90,91],
  'Salud/Farmacéutica': [0,84,90,92,90,91],
  Construcción: [0,84,90,92,90,91],
};

const ordenVentaDataByIndustry2024 = {
  Alimentos: [97,98,83,93,94,91],
  Retail: [97,98,83,93,94,91],
  Logística: [97,98,83,93,94,91],
  Manufactura: [97,98,83,93,94,91],
  Automotriz: [97,98,83,93,94,91],
  'Salud/Farmacéutica': [97,98,83,93,94,91],
  Construcción: [97,98,83,93,94,91],
};

const OrdenVentaPerfectaHorizontalBar = ({ selectedIndustries = [] }) => {
  const [infoOpen, setInfoOpen] = useState(false);

  const labels = ['Entre 1 y 10', 'Entre 11 y 50', 'Entre 51 y 100', 'Entre 101 y 250','Entre 251 y 1,000', 'Más de 1000'];

  const calculateCombinedData = (industries, dataByIndustry) => {
    const combinedData = Array(6).fill(null);
    let industryCount = Array(6).fill(0);

    industries.forEach((industry) => {
      const data = dataByIndustry[industry] || [];
      data.forEach((value, index) => {
        if (value !== null) {
          combinedData[index] = (combinedData[index] || 0) + value;
          industryCount[index] += 1;
        }
      });
    });

    return combinedData.map((sum, index) =>
      sum !== null && industryCount[index] > 0 ? Math.round(sum / industryCount[index]) : null
    );
  };

  const industriesToUse = selectedIndustries.length > 0 ? selectedIndustries : Object.keys(ordenVentaDataByIndustry2023);

  const dataValues2023 = calculateCombinedData(industriesToUse, ordenVentaDataByIndustry2023);
  const dataValues2024 = calculateCombinedData(industriesToUse, ordenVentaDataByIndustry2024);

  const chartData = {
    labels: labels,
    datasets: [
      {
        label: '2022',
        data: dataValues2023,
        backgroundColor: '#1F3D58',
        borderColor: '#fff',
        borderWidth: 1,
      },
      {
        label: '2023',
        data: dataValues2024,
        backgroundColor: '#A2AEBB',
        borderColor: '#fff',
        borderWidth: 1,
      },
    ],
  };

  const options = {
    layout: {
      padding: {
        top: 20,
        bottom: 40, // Aumenta este valor si es necesario
      }},
    responsive: true,
    maintainAspectRatio: false,
    indexAxis: 'y',
    plugins: {
      legend: { position: 'top' },
      datalabels: {
        color: '#fff',
        anchor: 'center',
        align: 'right',
        formatter: (value) => (value !== null ? `${value}%` : ''),
        font: { weight: 'bold', size: 14 },
      },
      tooltip: {
        callbacks: {
          label: (context) => `${context.dataset.label}: ${context.raw}%`,
        },
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: 'Porcentaje (%)',
        },
        beginAtZero: true,
        max: 100,
        ticks: {
          stepSize: 10,
        },
      },
      y: {
        title: {
          display: true,
          text: 'Rango de Empleados',
        },
      },
    },
  };

  const infoContent = {
    Analisis: 'En 2023, las empresas más grandes lideran en orden de venta perfecta por numero de empleados, reflejando una mayor eficiencia operativa. Las empresas medianas muestran estabilidad, mientras que las más pequeñas presentan menor desempeño, indicando posibles áreas de mejora en su cadena de suministro.',
    formula: 'Orden de Venta Perfecta (%) = (Órdenes entregadas completas, a tiempo y sin errores / Total de órdenes) × 100',
    description: 'La gráfica muestra el porcentaje promedio de órdenes de venta perfectas distribuidas por rangos de empleados en diferentes industrias para los años 2022 y 2023. Este indicador mide la eficiencia y precisión de los procesos de entrega.',
  };
  
  return (
    <div style={{ width: '100%', height: '520px' }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <MuiTooltip title="Información de la gráfica">
          <IconButton onClick={() => setInfoOpen(true)}>
            <InfoIcon />
          </IconButton>
        </MuiTooltip>
      </Box>
      <Bar data={chartData} options={options} />
      <Dialog open={infoOpen} onClose={() => setInfoOpen(false)}>
        <DialogTitle>Información de la Gráfica</DialogTitle>
        <DialogContent>
        <p><strong>Análisis:</strong> {infoContent.Analisis}</p>
          <p><strong>Fórmula:</strong> {infoContent.formula}</p>
          <p><strong>Descripción:</strong> {infoContent.description}</p>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setInfoOpen(false)} color="primary">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
  
};

export default OrdenVentaPerfectaHorizontalBar;
